import { useState } from 'react';
import { Stack, Group, Tabs, Button, Text } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import cn from 'clsx';
import { ContentCard } from 'src/components/ContentCard/ContentCard';
import { LatestRequest } from 'src/types';
import { RequestPanel } from './RequestPanel';
import { ClaimPanel } from './ClaimPanel';

const TABS = ['request', 'claim'];

const Heading = (
  <Text size="lg" fw={700}>
    Unstake MON
  </Text>
);

export function ClaimPage() {
  const [_searchParams, setSearchParams] = useSearchParams();
  const searchParams = Object.fromEntries(_searchParams.entries());
  const tabFromSearchParams = searchParams?.tab;
  const [activeTab, setActiveTab] = useState(
    TABS.includes(tabFromSearchParams) ? tabFromSearchParams : TABS[0]
  );
  const [latestRequest, setLatestRequest] = useState<LatestRequest | null>(
    null
  );

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    setSearchParams({ tab: value });
  };

  return (
    <Stack gap={36}>
      <Group justify="center" gap={16} wrap="nowrap">
        {TABS.map((tab) => (
          <Button
            key={tab}
            w={160}
            h={48}
            variant="outline"
            className={cn(
              'text-main0 hover:text-main0 active:text-main0 capitalize hover:bg-[rgba(124,77,255,0.10)]',
              tab === activeTab
                ? 'border-secondarypurple bg-[rgba(124,77,255,0.10)]'
                : 'border-white/[0.14]'
            )}
            onClick={() => handleTabChange(tab)}
          >
            {tab}
          </Button>
        ))}
      </Group>

      <ContentCard wrapperProps={{ w: 736 }}>
        <Tabs value={activeTab}>
          <Tabs.Panel value="request">
            <RequestPanel
              heading={Heading}
              onRequestSuccess={(_latestRequest: LatestRequest) => {
                setLatestRequest(_latestRequest);
                handleTabChange('claim');
              }}
            />
          </Tabs.Panel>
          <Tabs.Panel value="claim">
            <ClaimPanel heading={Heading} latestRequest={latestRequest} />
          </Tabs.Panel>
        </Tabs>
      </ContentCard>
    </Stack>
  );
}
